import React, {Component} from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import {initNavbarState} from 'actions/navbar.js';

import DatabaseService from 'services/DatabaseService.js';
import GroupSelectContainer from './GroupSelectContainer.js';

class SetGroupContainer extends Component {
    constructor(props) {
        super(props);
        this.onSwitchCompany = this.onSwitchCompany.bind(this);
    }
    componentWillMount() {
        if(this.props.isSwitch) {
            this.props.dispatch(initNavbarState({enable:true, backButtonEnable:true, title: this.props.t('Switch Organizations')}));
        }
    }
    onSwitchCompany() {
        var surveys = DatabaseService.getSurveysCache();
        if (surveys.onboarding) {
            delete sessionStorage.onboardingContainerState;
            this.props.history.push('/onboarding');
        } else if(this.props.isSwitch) {
            this.props.history.push('/settings');
        } else {
            this.props.history.push('/home');
        }
    }
    render() {
        return <GroupSelectContainer onSwitchCompany={this.onSwitchCompany} noNav={this.props.isSwitch} isSwitch={this.props.isSwitch} />
    }
};

export default withRouter(connect()(translate('authentication')(SetGroupContainer)));



// WEBPACK FOOTER //
// ./src/modules/authentication/SetGroupContainer.js